import React from 'react';
import { MobileActions } from '../ActionStrip';

var A4_MobileActions = function A4_MobileActions(props) {
  return /*#__PURE__*/React.createElement(MobileActions, props);
};

export { A4_MobileActions };